var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"footer"},[_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://m.suhuishou.com"}},[_vm._v("卖手机")])]),_c('div',{staticClass:"item active"},[_c('span',[_vm._v("换新机")])]),_c('div',{staticClass:"item"},[_c('a',{attrs:{"href":"https://m.suhuishou.com/user"}},[_vm._v("我的")])])])
}]

export { render, staticRenderFns }